import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makePath } from 'helpers/link-generation';
import Button from 'components/Button';
import Message from 'components/Message';
import { messages } from './Instructors.messages';

const AddInstructorButton = ({ activeVenueId }) => (
  <Link to={makePath.instructorsCreate({ venueId: activeVenueId })}>
    <Message as={Button} styled="primary" message={messages.buttons.addInstructor} />
  </Link>
);

AddInstructorButton.propTypes = {
  activeVenueId: PropTypes.number,
};

export default AddInstructorButton;
